import moment from 'moment';
import config from './config';

export const toCrop = amount => {
  const max = amount || 0;
  return string => {
    const value = (+string || 0).toFixed(+amount + 2);
    const reg = new RegExp(`\\d+(?:\\.\\d{0,${max}})?`);
    return `${value}`.match(reg)[0];
  };
};

export const numberValidation = text => {
  if (text === '') return false;
  return (
    /^(?:[0-9]{1,8}[\.][0-9]{1,8}|[0-9]{1,8}[\.]|[0-9]{1,8})$/.test(text) ||
    /^(?:[0-9]{1,8}[\.][0-9]{1,11}|[0-9]{1,8}[\.]|[0-9]{1,8})$/.test(text)
  );
};

export const firstLatterToUppercase = word => {
  const string = String(word);
  if (!string.trim().length) return '';
  return string?.charAt(0).toUpperCase() + string?.slice(1);
};

export const userName = (name, lastName) => {
  return name && lastName ? `${name} ${lastName}` : name || lastName || 'no name';
};

export const transformData = (time, format) => {
  if (typeof time === 'number') {
    return moment(time * 1000).format(format || 'DD-MM-YYYY HH:mm:ss');
  }
  return time;
};

export const subtractMonth = (date = new Date()) => {
  return new Date(date.getFullYear(), date.getMonth() - 1, date.getDate());
};

export const concatDateTime = (date, time) => {
  return (
    moment(date).format('YYYY-MM-DD') +
    (time < 10 ? ` 0${time}:00:00` : ` ${time}:00:00`)
  );
};

export const passwordValid = password => {
  if (password.length <= 6) return false;
  return /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[_#?!@$%^&*-]).{8,}$/.test(
    password,
  );
};

export const emailValid = email => {
  const regExp =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,4}))$/;
  return regExp.test(email);
};

// ???
const hostname = window?.location?.hostname;
export const prod = hostname.includes('admin.betconix.com');
const protocol = window?.location?.protocol;
export const reqUrl = () => {
  if (hostname === '127.0.0.1') return `http://${hostname}:8965`;

  if (protocol === 'http:' && hostname !== 'localhost')
    return `http://${hostname}:8965`;

  if (protocol === 'https:') return `https://${hostname}:8965`;

  return `http://${config.host}:8965`;
};

export const uploadFile = href => {
  const parseHref = href.split('/');
  const fileName = parseHref[parseHref.length - 1];
  const parseFileName = fileName.split('.');
  const format = parseFileName[parseFileName.length - 1];
  if (format === 'xml') {
    fetch(href)
      .then(data => {
        console.log({ data });
        return data.text();
      })
      .then(data => {
        console.log({ data });
        const a = document.createElement('a');
        const file = new Blob([data], { type: 'text/plain' });

        a.href = URL.createObjectURL(file);
        a.download = fileName;
        a.click();

        URL.revokeObjectURL(a.href);
      });
  }
};
export const checkPermissions = (arr, allPermissions) => {
  return !!arr.filter(permission => allPermissions.find(item => item === permission))
    .length;
};

export const toBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

export const convertTimestampWithTimezone = timezone => {
  const transformDate = transformData(timezone, 'YYYY-MM-DD HH:mm:ss');
  const timeUTC = moment.utc(transformDate);
  const localDate = moment(timeUTC).local();
  const localDateFormat = localDate.format('YYYY-MM-DD HH:mm:ss');

  return localDateFormat;
};
